/** @jsx jsx */
import { jsx } from 'theme-ui'
import { CategoryCarouselItem } from './CategoryCarouselItem'

export const CategoryCarousel = ({ tab }) => {
  return (
    <div
      sx={t => ({
        display: ['flex', 'none'],
        gap: '10px',
        paddingLeft: '18px',
        paddingTop: '68px',
        paddingBottom: '50px',
        background: `linear-gradient(to bottom, ${t.colors.primary} 40%, rgba(255,255,255,0) 80%);`,
        overflowX: 'auto',
        zIndex: '10',
        scrollbarWidth: 'none',
        '::-webkit-scrollbar': {
          display: 'none',
        },
      })}
    >
      {tab?.mobilePages.map(navItem => (
        <CategoryCarouselItem key={navItem?.slug} item={navItem} />
      ))}
    </div>
  )
}
